module.exports = __webpack_public_path__ + "img/top-white-icon.98ce60c0.svg";